import { Feature } from '../store/features/types';

export const isFeatureSelected = (
  features: Record<Feature, boolean>,
  feature: Feature
) => Boolean(features[feature]);
